import React from 'react'
import { TableHeadersType } from '../../../../constant/tableHeadersConstants/tableHeadersType';
import { formatDate, formateDateTime } from '../../../../utils/commonFunctions';
import UpdatedByAndUpdatedAt from '../../../commons/CommonUpdatedByAndUpdatedAt';
type AppProps={
    recurringJobsList:any;
    tableHeader:TableHeadersType[];
    handleEditRecurringJobSetting:(data:any)=>void;
  }

const RecurringJobsSettingTableData = ({
  recurringJobsList,
  tableHeader,
  handleEditRecurringJobSetting
}:AppProps) => {

  return (
    <>
    {
        recurringJobsList?.length>0&&recurringJobsList?.map((itemData:any)=>{
            const finalData={clientCode:itemData?.client_code,companyName:itemData?.client_name}
            return<tr key={recurringJobsList?._id}>
            {
              tableHeader?.map((item:TableHeadersType)=>{
                if(item?.value==="client_name"){
                    return<td>
                        <span onClick={()=>handleEditRecurringJobSetting(finalData)}
                        className='pointer'
                         style={{ textDecoration:"underline",color:"#262a44",fontWeight:"500",textUnderlineOffset: '3px'}}
                        >{itemData?.client_name?itemData?.client_name:"--/--"}</span>
                    </td>
                }
                else if(item?.value==="job_type"){
                    return<td>{itemData?.job_type?.job_type?itemData?.job_type?.job_type:"--/--"}</td>
                }
                else if(item?.value==="period_length"){
                    return<td>{itemData?.job_type?.repeat_period_length?`${itemData?.job_type?.repeat_period_length} ${itemData?.job_type?.repeat_period}`:"--/--"}</td>
                }
                else if(item?.value==="next_period_end"){
                    return<td>{itemData?.job_type?.next_period_end_date?`${formatDate(itemData?.job_type?.next_period_end_date)}`:"--/--"}</td>
                }
                else if(item?.value==="create_job_at"){
                    return<td>{itemData?.job_type?.create_job_period?`${itemData?.job_type?.create_job_period}`:"--/--"}</td>
                }
                else if (item?.value === "updated_by") {
                  return (
                    <td style={{width:'260px'}}>
                       <UpdatedByAndUpdatedAt
                        firstName={itemData?.updated_by?.first_name}
                        lastName={itemData?.updated_by?.last_name}
                        profilePic={itemData?.updated_by?.profile_pic?.file_url}
                        updatedAt={formateDateTime(itemData?.updated_at)}
                        />
                      
                    </td>
                  );
                }
                return<td>{itemData[item?.value]}</td>
              })  
            }
            </tr>
        })
    }
    </>
  )
}

export default RecurringJobsSettingTableData